import { css, Theme } from "@emotion/react";
import { media } from "styles/breakpoints";

export const AboutUsBlockStyle = {
  self: css`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    ${media.xxl} {
      padding: 0 60px;
    }
    ${media.md} {
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
    }
    ${media.sm} {
      grid-template-columns: 1fr;
    }
  `,

  box: css`
    &:last-of-type {
      text-align: right;
    }
    ${media.md} {
      text-align: center;
    }
  `,
  boxTitle: ({ fontSize }: Theme) => css`
    font-size: ${fontSize[20]};
    font-weight: 500;
    text-transform: uppercase;
    margin-bottom: 30px;
  `,
  boxContent: css`
    width: 100%;
    img {
      max-width: 100%;
    }
    ${media.md} {
      display: flex;
      justify-content: center;
    }
  `,

  socials: css`
    display: flex;
    gap: 20px;
  `,
  socialButton: ({ colors }: Theme) => css`
    display: inline-flex;
    width: 60px !important;
    height: 60px;
    background-color: ${colors.orange[200]} !important;
    justify-content: center;
    align-items: center;
    font-size: 30px;
  `,
  socialIcon: css`
    path {
      fill: white;
    }
  `,
};
